import { useMutation } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

import type { ExtractionFeedbackRequest, ValidateRequest, ValidationReport } from './types';

export function useValidateCriteria() {
  return useMutation({
    mutationFn: (body: ValidateRequest) =>
      apiFetch<ValidationReport>('/criteria/validate', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
  });
}

export function useSubmitExtractionFeedback() {
  return useMutation({
    mutationFn: (body: ExtractionFeedbackRequest) =>
      apiFetch<{ success: boolean }>('/extraction-feedback', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
  });
}
